import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    userInfo: JSON.parse(localStorage.getItem('admin_user') || '{}')
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    
    SET_USER_INFO(state, userInfo) {
      console.log('🔍 SET_USER_INFO 接收到的用户信息:', userInfo)
      console.log('🔍 校区相关字段:', {
        campusId: userInfo.campusId,
        campus_id: userInfo.campus_id,
        deptId: userInfo.deptId,
        dept_id: userInfo.dept_id
      })
      state.userInfo = userInfo
      localStorage.setItem('admin_user', JSON.stringify(userInfo))
    },
    
    CLEAR_LOGIN_INFO(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
    }
  },
  
  actions: {
    // 登录
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_LOGIN_INFO')
    }
  },
  
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.userInfo,
    
    // 辅助函数：判断是否为总校区ID（处理bigint类型）
    _isMainCampusId: () => (value) => {
      if (value === null || value === undefined) return false
      // 处理bigint、string、number类型的0
      return value === 0 || value === '0' || value === 0n || 
             String(value) === '0' || Number(value) === 0
    },
    
    // 辅助函数：判断是否为有效的分校区ID（处理bigint类型）
    _isValidCampusId: (state, getters) => (value) => {
      if (value === null || value === undefined) return false
      // 不是总校区且有值
      return !getters._isMainCampusId(value) && 
             (value !== '' && value !== 0 && value !== '0' && value !== 0n)
    },
    
    // 判断是否是总校区管理员（身份为管理员 + campus_id = 0）
    isSuperAdmin: (state, getters) => {
      const userInfo = state.userInfo
      if (!userInfo || (userInfo.userType !== 'ADMIN' && userInfo.roleType !== 'ADMIN')) {
        return false
      }
      
      const campusId = getters.userCampusId
      const result = getters._isMainCampusId(campusId)
      console.log('🔍 isSuperAdmin 判断:', {
        userType: userInfo.userType,
        campusId: campusId,
        isMainCampus: result
      })
      return result
    },
    
    // 获取用户所属校区ID
    userCampusId: state => {
      const userInfo = state.userInfo
      if (!userInfo) return null
      
      // 尝试多种可能的校区字段名（使用严格判断，避免0被当作false）
      // 优先使用 campusId（后端返回的驼峰命名）
      if (userInfo.campusId !== null && userInfo.campusId !== undefined) {
        return userInfo.campusId
      }
      if (userInfo.campus_id !== null && userInfo.campus_id !== undefined) {
        return userInfo.campus_id
      }
      if (userInfo.deptId !== null && userInfo.deptId !== undefined) {
        return userInfo.deptId
      }
      if (userInfo.dept_id !== null && userInfo.dept_id !== undefined) {
        return userInfo.dept_id
      }
      return null
    },
    
    // 判断是否是分校区管理员
    isCampusAdmin: (state, getters) => {
      const userInfo = state.userInfo
      if (!userInfo || (userInfo.userType !== 'ADMIN' && userInfo.roleType !== 'ADMIN')) {
        return false
      }
      
      const campusId = getters.userCampusId
      return getters._isValidCampusId(campusId)
    },
    
    // 获取用户校区身份显示文本
    userCampusText: (state, getters) => (campusList = []) => {
      const campusId = getters.userCampusId
      
      // 总校区判断
      if (getters._isMainCampusId(campusId)) {
        return '总校区'
      }
      
      // 分校区判断
      if (getters._isValidCampusId(campusId)) {
        const searchId = String(campusId) // 转为字符串进行搜索
        const campus = campusList.find(c => 
          String(c.id) === searchId || 
          c.id === campusId ||
          Number(c.id) === Number(campusId)
        )
        return campus ? (campus.campusName || campus.name) : `校区${campusId}`
      }
      
      return '未分配校区'
    }
  }
})

